import { render, staticRenderFns } from "./CPRiepilogo.vue?vue&type=template&id=08e59542"
import script from "./CPRiepilogo.vue?vue&type=script&lang=js"
export * from "./CPRiepilogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports